<template>
  <div>
    <v-row class="pt-0">
      <v-col cols="12" sm="6" lg="3">
        <dashboard-card title="Realizar nova terapia">
          <div class="d-flex flex-column align-center" style="min-height: 60px">
            <v-btn class="primary" large rounded @click="newTherapy">
              Clique aqui
            </v-btn>
          </div>
        </dashboard-card>
        <v-spacer />
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <dashboard-card title="Terapias realizadas nos últimos 7 dias">
          <dashboard-text
            :text="performedTherapiesLast7Days"
            min-height="0px"
          />
        </dashboard-card>
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <dashboard-card title="Terapias realizadas hoje">
          <dashboard-text :text="performedTherapiesToday" />
        </dashboard-card>
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <dashboard-card title="Agendamentos para hoje">
          <dashboard-text :text="confirmedAppointmentsToday" />
        </dashboard-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="6">
        <dashboard-card title="Agendamentos">
          <simplified-appointments-calendar :events="calendarEvents" />
        </dashboard-card>
      </v-col>
      <v-col cols="12" lg="6">
        <dashboard-card title="Histórico de rastreios">
          <therapies-list
            :therapies="therapiesHistory"
            :is-loading="isLoadingTherapiesHistory"
            name-route-detailed="therapys"
            @view-diagnosis="handleViewDiagnosis"
            @resume-therapy="handleResumeTherapy"
          />
        </dashboard-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="6">
        <dashboard-card title="Agendamentos pendentes de aprovação">
          <appointments-to-approve class="text-left" />
        </dashboard-card>
      </v-col>
      <v-col cols="12" lg="6">
        <dashboard-card title="Assinatura">
          <subscription-card
            :current-subscription="currentSubscription"
            :is-loading-subscription="isLoadingSubscription"
          />
        </dashboard-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getTherapistDashboardData } from "@/services/external/dashboard.service";
import { getDraftContent } from "@/services/external/therapy-draft-service";
import SubscriptionCard from "@/domains/dashboard/presentation/components/SubscriptionCard";

export default {
  components: {
    SubscriptionCard,
    AppointmentsToApprove: () =>
      import(
        "@/domains/appointments/therapist/presentation/components/ToApprove"
      ),
    DashboardCard: () =>
      import("@/domains/dashboard/presentation/components/DashboardCard"),
    DashboardText: () =>
      import("@/domains/dashboard/presentation/components/DashboardText"),
    TherapiesList: () =>
      import(
        "@/domains/dashboard/presentation/components/SimplifiedTherapiesList"
      ),
    SimplifiedAppointmentsCalendar: () =>
      import(
        "@/domains/dashboard/presentation/components/SimplifiedAppointmentsCalendar"
      ),
  },
  data: () => ({
    performedTherapiesToday: 0,
    performedTherapiesLast7Days: 0,
    confirmedAppointmentsToday: 0,
    therapiesHistory: [],
    isLoadingTherapiesHistory: true,
    calendarEvents: [],
    currentSubscription: {
      nextBillingTime: "",
      productTypeLabel: "",
    },
    isLoadingSubscription: true,
  }),
  computed: {
    subscriptionProductType() {
      return this.$store.getters["login/subscriptionProductType"];
    },
  },
  mounted() {
    console.log(this.subscriptionProductType);
    if (!this.subscriptionProductType) {
      this.$router.push({ name: "subscriptions.my" });
    }
  },
  created() {
    this.fillData();
  },
  methods: {
    async fillData() {
      try {
        const { data } = await getTherapistDashboardData();
        const {
          performedTherapiesToday,
          performedTherapiesLast7Days,
          confirmedAppointmentsToday,
          therapiesHistory,
          calendarEvents,
          currentSubscription,
        } = data;
        this.performedTherapiesToday = performedTherapiesToday;
        this.performedTherapiesLast7Days = performedTherapiesLast7Days;
        this.confirmedAppointmentsToday = confirmedAppointmentsToday;
        this.therapiesHistory = therapiesHistory;
        this.calendarEvents = calendarEvents;
        this.currentSubscription = currentSubscription;
      } catch (error) {
        console.error("Erro ao carregar dados do dashboard:", error);
      } finally {
        this.isLoadingTherapiesHistory = false;
        this.isLoadingSubscription = false;
      }
    },
    newTherapy() {
      this.$store.dispatch("therapy/newTherapy");
    },
    handleViewDiagnosis(therapy) {
      // Navega para visualizar o diagnóstico pela rota usada no TherapysList
      if (therapy?.protocol) {
        this.$router.push({
          name: "therapistReview",
          query: { protocol: therapy.protocol },
        });
      } else {
        this.$toasted.error(
          "Não foi possível abrir o diagnóstico: protocolo ausente."
        );
      }
    },
    async handleResumeTherapy(therapy) {
      try {
        // Se for um rascunho (DRAFT), buscar conteúdo completo do S3
        if (therapy?.status === "DRAFT" && therapy?.id) {
          this.$store.dispatch("loading/openDialog");

          const therapyData = await getDraftContent(therapy.id);
          await this.$store.dispatch("therapy/loadTherapy", therapyData);

          this.$store.dispatch("loading/closeDialog");
          this.$router.push({ name: "therapys.stepper" });
          return;
        }

        // Fallback: tenta carregar diretamente (casos locais/em progresso)
        await this.$store.dispatch("therapy/loadTherapy", therapy);
        this.$router.push({ name: "therapys.stepper" });
      } catch (error) {
        console.error("[Dashboard] Erro ao continuar terapia:", error);
        this.$store.dispatch("loading/closeDialog");
        this.$toasted.error("Erro ao recuperar terapia. Tente novamente.");
      }
    },
  },
};
</script>

<style scoped></style>
